import styled from 'styled-components';
import { type WarningBarVariant } from './WarningBar';

interface VariantProps {
	variant: WarningBarVariant;
}

const getBackgroundColor = (variant: WarningBarVariant) => {
	if (variant === 'info') return '#e0f2f7';
	return '#fff3e0'; // Light orange background for warning
};

const getBorderColor = (variant: WarningBarVariant) => {
	if (variant === 'info') return '#b3e5fc';
	return '#FDCB7E'; // Warning variant
};

const getIconContainerBg = (variant: WarningBarVariant) => {
	if (variant === 'info') return '#2196f3';
	return '#FAA21B'; // Warning variant
};

export const WarningBarContainer = styled.div<VariantProps>`
	width: 100%;
	display: flex;
	align-items: center;
	background-color: ${props => getBackgroundColor(props.variant)};
	border: ${props => `1px solid ${getBorderColor(props.variant)}`};
	// border-bottom: ${props => `1px solid ${getBorderColor(props.variant)}`};
	padding: 0px 12px 0px 0px;
	gap: 1rem;
	min-height: auto;
	margin-bottom: 1rem;
`;

export const IconContainer = styled.div<VariantProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${props => getIconContainerBg(props.variant)};
	border-radius: 0px;
	width: 40px;
	flex-shrink: 0;
	align-self: stretch;
`;

export const MessageText = styled.div<VariantProps>`
	flex: 1;
	color: #333;
	text-align: left;
	padding: 12px 0px;
	font-size: 1rem;
`;

export const CloseButtonContainer = styled.div`
	display: flex;
	align-items: center;
	flex-shrink: 0;
	margin-left: auto;
`;
